import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import callAPI from "../../../../../../../api/apiCaller";
import Button from "../../../../../../../common/Button";
import { ButtonSpacer } from "../../../../../../../common/Button/styles";
import Loading from "../../../../../../../common/Loading";
import Pills from "../../../../../../../common/Pills";
import Notes from "./Notes";
import { useLocation, useSearchParams } from "react-router-dom";
import {
  ConnectionProfileContainer,
  ConnectionProfileHeader,
  ProfileImage,
  ProfileInfo,
  ProfileHeader,
  ProfileName,
  ProfileDescription,
  ProfileActions,
  PillsContainer,
  BackButton,
  ProfileInfoContainer,
} from "./styles";
import Tasks from "./Tasks";
import Timesheet from "./Timesheet";
import Updates from "./Updates";
import { Context } from "../../../../../../../Store";
import features from "../../../../../../../config/features";
import Boards from "./Collaborate";
import MeetingsTab from "./MeetingsTab";

function ConnectionProfile() {
  const [searchParams] = useSearchParams();
  let params = useParams();
  let navigate = useNavigate();
  const [profile, setProfile] = React.useState(null);
  const { state, dispatch } = React.useContext(Context);
  const role = searchParams.get("role");
  const [taskCount, setTaskCount] = useState(null);
  // let recipientId = searchParams.get("recipientId");

  const userId = params.id ? params.id : params.connectionId;
  React.useEffect(() => {
    callAPI(
      dispatch,
      role === "mentor" ? "getSelectedMentee" : "getSelectedMentor",
      { id: params.connectionId }
    ).then((connectionProfile) => {
      if (connectionProfile.isResponseOk) {
        setProfile(connectionProfile.data);
      }
    });
  }, []);

  /**** START TEST HERE *****/
  // const params = useParams();
  const recipientId = params.connectionId;

  function getTasks() {
    // !isTeam
    //   ?
    return callAPI(dispatch, "menteeTasks", {
      rid: role === "mentee" ? +state.user.id : +recipientId,
      id: params.selectedProgram,
    }).then((retrievedTasks) => {
      if (retrievedTasks.isResponseOk) {
        // setTasks(retrievedTasks.data);

        //
        // if (setTaskCount) {
        const length = retrievedTasks?.data?.filter(
          (task) => task?.status === "pending"
        )?.length;

        setTaskCount(length === 0 ? null : length);
        // }
        //
      }
    });
    // :
    //  callAPI(dispatch, "teamTasks", { id: params.connectionId }).then(
    //     (retrievedTasks) => {
    //       if (retrievedTasks.isResponseOk) {
    //         setTasks(retrievedTasks.data);

    //         //
    //         if (setTaskCount) {
    //           const length = retrievedTasks?.data?.filter(
    //             (task) => task?.status === "pending"
    //           )?.length;

    //           setTaskCount(length === 0 ? null : length);
    //         }
    //         //
    //       }
    //     }
    //   );
  }

  React.useEffect(() => {
    getTasks();
  }, []);
  /**** START TEST HERE *****/

  if (profile === null) {
    return <Loading loadingItem="Connection Profile" />;
  }
  return (
    <ConnectionProfileContainer>
      <ConnectionProfileHeader>
        {/* <BackButton>
      <Button icon="back" onClick={() => { navigate(`/programs/${params.selectedProgram}/${params.tab}`) }} />
    </BackButton> */}
        <ProfileInfoContainer>
          <ProfileImage
            src={
              profile?.image
                ? profile?.image
                : "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"
            }
          />
          <ProfileInfo>
            <ProfileHeader>
              <ProfileName>
                {profile?.firstName + " " + profile?.lastName}
              </ProfileName>
              <ProfileDescription>{profile?.bio}</ProfileDescription>
            </ProfileHeader>
            <ProfileActions>
              <Button
                icon="chat"
                onClick={() => {
                  callAPI(dispatch, "initializeConversation", {
                    id: profile?.id,
                  })
                    .then((res) => {
                      if (res) {
                        navigate("/messages/" + profile?.uuid);
                      }
                    })
                    .catch((error) => {
                      console.error(error);
                    });
                }}
              />
              <ButtonSpacer />
              <Button
                icon="calendar"
                onClick={() => {
                  navigate("/programs/added-to-calendar");
                }}
              />
            </ProfileActions>
          </ProfileInfo>
        </ProfileInfoContainer>
        <PillsContainer>
          <Pills
            meetings={true}
            isWidth={true}
            count={taskCount}
            options={[
              ...(features.updates
                ? [
                    {
                      label: "Updates",
                      value: "updates",
                    },
                  ]
                : []),

              ...(features.meetings
                ? [
                    {
                      label: "Meetings",
                      value: "meetings",
                    },
                  ]
                : []),
              ...(features.collaborate
                ? [
                    {
                      label: "Collaborate",
                      value: "collaborate",
                    },
                  ]
                : []),
              ...(features.notes
                ? [
                    {
                      label: "Personal Notes",
                      value: "notes",
                    },
                  ]
                : []),
              ...(features.timesheet
                ? [
                    {
                      label: "Timesheet",
                      value: "timesheet",
                    },
                  ]
                : []),
              {
                label: "Tasks",
                value: "tasks",
              },
            ]}
            value={params.connectionTab}
            setValue={(newValue) => {
              navigate(
                `/programs/${params.selectedProgram}/${params.tab}/${params.connectionId}/${newValue}?role=${role}`
              );
            }}
          />
        </PillsContainer>
      </ConnectionProfileHeader>

      {features.updates && params.connectionTab === "updates" && <Updates />}

      {features.notes && params.connectionTab === "notes" && <Notes />}

      {features.timesheet && params.connectionTab === "timesheet" && (
        <Timesheet />
      )}

      {params.connectionTab === "tasks" && (
        <Tasks setTaskCount={setTaskCount} />
      )}

      {features.collaborate && params.connectionTab === "collaborate" && (
        <Boards />
      )}

      {features.meetings && params.connectionTab === "meetings" && (
        <MeetingsTab />
      )}
    </ConnectionProfileContainer>
  );
}
export default ConnectionProfile;
